<template>
    <vx-card  class="carousel-example">
        <swiper :options="swiperOption" :dir="$vs.rtl ? 'rtl' : 'ltr'" :key="$vs.rtl">
            <swiper-slide v-bind:key="index" v-for="(producto, index ) in listProductsComplete" >
                        <div class="card ecommerce-card" style="padding-top: 10px;" >
                            <div class="card-content">
                                <div class="item-img text-center" style=" padding-top: 0.5rem; min-height: 15.85rem;">
                                    <template v-if="producto.imageUrl == ''">
                                        <img class="img-fluid img-custom" v-bind:src="require('@/assets/images/no-imagen.jpg')" alt="img-placeholder" >
                                    </template>
                                    <template v-else>
                                        <img class="img-fluid" v-bind:src="$store.state.api+'mapgrafi/ecommerce/searchFile/'+producto.imageUrl" alt="img-placeholder"  style="margin:auto;width:160px !important; height:180px !important;">
                                    </template>
                                </div>
                                <div class="card-body">
                                    <div class="item-wrapper">
                                        <div class="item-rating">
                                            <div class="badge badge-primary badge-md">
                                                <span></span> <i class="feather icon-star"></i>
                                            </div>
                                        </div>
                                        <div style="display: flex; gap: 10px;">
                                            <span class="item-price" style="color: red; white-space: nowrap;">* Precio sin IVA.</span>
                                            <span class="item-price" >$ </span><span class="item-price"  v-text="parseFloat(producto.price).toFixed(2)"> </span>
                                        </div>
                                    </div>
                                    <div class="item-name" style="overflow: hidden; white-space: nowrap; text-overflow: ellipsis;">
                                        <span  v-text="producto.name"></span>
                                    </div>
                                    <div>
                                        <p class="item-description" style="overflow: hidden; white-space: nowrap; text-overflow: ellipsis;" v-text="producto.description"></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <br>
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
            <!--div class="swiper-button-prev" color="primary" slot="button-prev"></div>
            <div class="swiper-button-next" color="primary" slot="button-next"></div-->
          </swiper>
    </vx-card>
</template>

<script>
import 'swiper/dist/css/swiper.min.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import StarRating from 'vue-star-rating'

export default {
    data() {
        return {
            listProductsComplete:[],
            productos:[],
            swiperOption: {
                slidesPerView: 3,
                spaceBetween: 50,
                // init: false,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },
                 navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                },
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false
                },
                  breakpoints: {
                    1024: {
                        slidesPerView:3,
                        spaceBetween: 40
                    },
                    768: {
                        slidesPerView: 3,
                        spaceBetween: 30
                    },
                    640: {
                        slidesPerView: 1,
                        spaceBetween: 20
                    }
                }
            }
        }
    },
    components: {
        swiper,
        swiperSlide,
        StarRating
    },
    created() {
      // Card 1
        this.$vs.loading();
        var _this = this;
        this.$http.post(_this.$store.state.domain+`mapgrafi/mapgrafi-general/producto-carga-general-destacados`,{
            cod_empresa:process.env.VUE_APP_COD_EMPRESA_ERP
        }).then((response) => { 
            this.$vs.loading.close();
            if(response.status == 200)
                if(!response.data.existeError){
                    _this.listProductsComplete = _.clone(response.data.data);
                }
        })
        .catch(error=>{
            this.$vs.loading.close();
            this.$vs.notify({
                        time:8000,
                        title: 'Mapgrafi informa',
                        text:  error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'warning'
            });
        });

        // this.$http.get(this.$store.state.domain+`mapgrafi/mapgrafi-general/producto-carga-general/D`)
        //       .then((response) => {   
        //         if(_.size(response.data.data) >0 ){
        //             var _this = this;
        //             _.forEach(response.data.data,function(producto){
        //                 console.log(producto);
        //                     var producto = new Promise((resolve, reject) => {
        //                             _this.$http.post(_this.$store.state.domain+`mapgrafi/ecommerce/producto`,{
        //                                 data:{
        //                                     method:"producto-carga-general",
        //                                     cod_producto: producto.id_cod_producto,
        //                                     estado: "A",
        //                                     tipo: "M",
        //                                     cod_clasificacion : null,
        //                                     positionPagination:"9"
        //                                 }
        //                             })
        //                             .then((response) => { 
        //                                 if(response.status == 200)
        //                                     if(!response.data.existeError){
        //                                         resolve(response.data.data[0]);
        //                                     }
        //                             })
        //                             .catch((error)=>{
        //                                 reject(error);
        //                             })
        //                     });
        //                     producto
        //                     .then((response)=>{
        //                         _this.listProductsComplete.push(response);
        //                     })
        //                     .catch((error)=>{
        //                     })
        //                     ;
        //             });
        //         }    
        //     this.$vs.loading.close();
        //     }).catch((error)=>{
        //         this.$vs.loading.close();
        //         this.$vs.notify({
        //                     time:8000,
        //                     title: 'Mapgrafi informa',
        //                     text:  error,
        //                     iconPack: 'feather',
        //                     icon: 'icon-alert-circle',
        //                     color: 'warning'
        //         });
        //     })

    }
    
}
</script>
